import { Component, OnInit, Inject, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../core/services/language.service';
import { EventService } from '../../core/services/event.service';
import { AuthenticationService } from '../../core/services/auth.service';
import { DOCUMENT } from '@angular/common';
import { MenuItem } from './menu.model';
import { MenuService } from 'src/app/core/services/menu.service';
import { SharedService } from 'src/app/core/services/shared.service';
import { MenuEvent } from 'src/app/core/services/menuevent.service';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalCustomComponent } from 'src/app/shared/ui/modal-custom/modal-custom.component';
import { CambiarContrasenaComponent } from '../cambiar-contrasena/cambiar-contrasena.component';
import { PARAMETROS_CLIENTE  } from 'src/app/core/config/config';
import { FiltrosPersistenciaService } from 'src/app/core/services/filtros-persistencia.service';
import Swal from 'sweetalert2';

// mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR
import { ThemeService } from 'src/app/core/services/theme.service';
@Component({
  selector: 'app-horizontaltopbar',
  templateUrl: './horizontaltopbar.component.html',
  styleUrls: ['./horizontaltopbar.component.scss']
})

/**
 * Horizontal Topbar and navbar specified
 */
export class HorizontaltopbarComponent implements OnInit, OnDestroy {


  ModuloDefault: any
  ModuloModalDefault: any
  MostrarFiltroPrincipal: any
  CNT05COD: any;
  M05COD: any;
  CNT05DES: any;
  M05DES: any;
  // almora 2026.05.09 — globales adicionales editables desde el header
  M18COD: any;
  M19COD: any;
  anios: any[] = [];
  periodos: any[] = [];
  element;
  cookieValue;
  flagvalue;
  countryName;
  valueset;
  strWsModulo: string = "api/mantenimientos/MenuModulos";
  MenuModulo = [];
  strWsnoti: string = "api/servicios/Notificaciones";
  strWsAcciones: string = "api/servicios/Acciones";
  strWsURLMENU: string = "api/mantenimientos/MenuPrincipal";
  strActualizarNoti: string = "api/servicios/ActualizarEstadoNotificacion";
  strWsURL: string = "api/mantenimientos/Favoritos/SEL/0";
  strMenuCopania: string = "api/servicios/SeleccionarCompania";
  strMenuSedesPorCopania: string = "api/servicios/SeleccionarSedePorCompania";
  strWsCboPeriodos: string = "api/servicios/cboPeriodos";  
  strWsCboPeriodoM19: string = "api/servicios/cboPeriodosM20";
  MenuCopania = [];
  megamenu: any[] = [];
  favoritos: any[] = [];
  filtroFavoritos = '';
  cargandoFavoritos = false;
  array: Array<string> = [];
  notificaciones: any[] = [];
  acciones: any[] = [];
  WsLlaves: string = '';
  cantidad: any;
  menuItems: any = [];
  id: string = '';
  Modulo: string = '';
  mostrar: any = 1;
  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
    { text: 'Spanish', flag: 'assets/images/flags/spain.jpg', lang: 'es' },
    { text: 'German', flag: 'assets/images/flags/germany.jpg', lang: 'de' },
    { text: 'Italian', flag: 'assets/images/flags/italy.jpg', lang: 'it' },
    { text: 'Russian', flag: 'assets/images/flags/russia.jpg', lang: 'ru' },
  ];
  ocultarMenu = false;
  strWebestudiante: string = "api/servicios_perfil/ListarPerfil"
  dataestudiante: any;
  interval: any;
  logo: String;
  analitica: boolean = false;
  deudas:boolean = false;

  // tslint:disable-next-line: max-line-length
  constructor(@Inject(DOCUMENT) private document: any, private router: Router, private eventService: EventService, private authService: AuthenticationService,
    private dataService: SharedService,
    public languageService: LanguageService,
    private menuEvent: MenuEvent,
    // tslint:disable-next-line: variable-name
    public _cookiesService: CookieService,
    public menuService: MenuService,
    // mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR
    private theme: ThemeService,
    private modalService: NgbModal,
    private filtrosPersistencia: FiltrosPersistenciaService) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.activateMenu();
      }
    });
    this.obtener_localstorage();
  }
  @ViewChild('contenido') contenido: TemplateRef<any>;
  @ViewChild('contenidosedes') contenidosedes: TemplateRef<any>;

  ngOnInit(): void {
    this.element = document.documentElement;
    this.initialize();
    this.initialize2();
    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter(x => x.lang === this.cookieValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) { this.valueset = 'assets/images/flags/us.jpg'; }
    } else {
      this.flagvalue = val.map(element => element.flag);
    }

    this.timerAlertas();

    // carga de logo registrado
    //this.logo = localStorage.getItem("X-AVATAR-CNT05LOG");
    this.obtenerLogo();
    this.validarDerechoAnalitica();

    this.deudas = sessionStorage.getItem('X-AVATAR-TIENE-DEUDA') === 'true';
  }

  validarDerechoAnalitica(){
    this.dataService.ConsultarWS("api/ws/msa/S02ARC_WS/validarDerecho", JSON.stringify({ S03COD: 'MSA-HABILITAR-ANALITICA' })).subscribe(datos => {
      if (datos.acceso == true) {
        this.analitica = true;
      }
    });
  }

  obtenerLogo(){

    // se obtiene y se agrega el dominio al servicio
    const protocolo =  window.location.protocol;
    const dominio =  window.location.host;
    let data = {
      LLAVES: [{CNT05DOM:protocolo+"//"+dominio}]
    };

    this.dataService.ConsultarWS("api/login/ObtenerLogo", JSON.stringify(data)).subscribe((datosResp2: any) => {

      // se graba nombre logo por efectos de la app - nueva funcionalidad carga de data por dominio
      localStorage.setItem("X-AVATAR-CNT05LOG",datosResp2.LOGO);
      // almora 2026.05.09 — idempotente: solo limpia si el contexto cambio realmente
      this.filtrosPersistencia.cambiarContextoHeader(datosResp2.CNT05COD, datosResp2.M05COD);
      localStorage.setItem("X-AVATAR-CNT05COD",datosResp2.CNT05COD);
      localStorage.setItem("X-AVATAR-M05COD",datosResp2.M05COD);
      // se carga logo compania
      this.logo = datosResp2.LOGO;
      // mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR
      // Tema de colores de la compañía (por dominio)
      this.theme.aplicarDesdeLogin(datosResp2, false);   // si no trae TEMA, conserva el del login

    });
  }

  ngOnDestroy(){
    clearInterval(this.interval);
  }

  /**
   * Initialize
   */
  initialize(): void {
    //notificaciones
    this.dataService.ConsultarWS(this.strWsnoti, JSON.stringify({ filtro: 'N', resumido: 0 })).subscribe((datosResp2: any) => {
      this.notificaciones = datosResp2.DATA;
      this.cantidad = datosResp2.NOLEIDO;
    });

    this.dataService.ConsultarWS(this.strWsAcciones, JSON.stringify({})).subscribe((data: any) => {
      this.acciones = data;
    });

    this.dataService.Consultar(this.strWebestudiante).subscribe((datosResp3: any) => {
      this.dataestudiante = datosResp3[0].NOMBRE
    });
  }

  initialize2(): void {

    // mospina 07-04-2026, Ajuste cambio de menu horizontal
    this.menuEvent.switchPerfilActivo.subscribe((modulo: any) => {

      this.ModuloDefault = modulo;

      let filtro = "";
      let jsonFiltros = JSON.parse("{ \"FILTROS_OPCIONALES\"   : [ { \"S14DES\" : \"" + filtro + "\", \"S02COD\" : \"" + this.ModuloDefault + "\" }]}");
      this.dataService.Ejecutar(this.strWsURLMENU, jsonFiltros).subscribe(
      (datosResp: any) => {
        this.menuItems = datosResp;
        // mospina - guardar CLITUT en localStorage
        if (datosResp && datosResp[0].CLITUT) {
          localStorage.setItem('CLITUT', datosResp[0].CLITUT);
        }
        this.ModuloModalDefault = datosResp[0].S02COD;
      });
    });

    if (this.ModuloDefault != null) {
      if (this.mostrar == 1) {
        let filtro = "";
        let jsonFiltros = JSON.parse("{ \"FILTROS_OPCIONALES\"   : [ { \"S14DES\" : \"" + filtro + "\", \"S02COD\" : \"" + this.ModuloDefault + "\" }]}");
        this.dataService.Ejecutar(this.strWsURLMENU, jsonFiltros).subscribe(
          (datosResp: any) => {
            this.menuItems = datosResp;
            // mospina - guardar CLITUT en localStorage
            if (datosResp && datosResp[0].CLITUT) {
              localStorage.setItem('CLITUT', datosResp[0].CLITUT);
            }
            this.ModuloModalDefault = datosResp[0].S02COD;
          });
      };
    } else {
      let filtro = "";
      let jsonFiltros = JSON.parse("{ \"FILTROS_OPCIONALES\"   : [ { \"S14DES\" : \"" + filtro + "\", \"S02COD\" : \"" + "" + "\" }]}");
      this.dataService.Ejecutar(this.strWsURLMENU, jsonFiltros).subscribe(
        (datosResp: any) => {
          this.menuItems = datosResp;
          // mospina - guardar CLITUT en localStorage
          if (datosResp && datosResp[0].CLITUT) {
            localStorage.setItem('CLITUT', datosResp[0].CLITUT);
          }
          this.ModuloModalDefault = datosResp[0].S02COD;
        })
    }

    this.menuEvent.switchMessageFormEvent.subscribe((codigo: string) => {
      let filtro = "";
      let jsonFiltros = JSON.parse("{ \"FILTROS_OPCIONALES\"   : [ { \"S14DES\" : \"" + filtro + "\", \"S02COD\" : \"" + codigo + "\" }]}");
      this.dataService.Ejecutar(this.strWsURLMENU, jsonFiltros).subscribe(
        (datosResp: any) => {
          this.menuItems = datosResp;
          // mospina - guardar CLITUT en localStorage
          if (datosResp && datosResp[0].CLITUT) {
            localStorage.setItem('CLITUT', datosResp[0].CLITUT);
          }
          this.ModuloModalDefault = datosResp[0].S02COD;
        });
    });

    this.menuEvent.switchAbrirModal.subscribe((codigo: string) => {
      if (this.CNT05COD == "" || this.CNT05COD == undefined || this.M05COD == null || this.M05COD == "" || this.M05COD == undefined || this.M05COD == null) {
        this.abrirModal("");
      }
    });
  }

  markUnread() {
    this.dataService.ConsultarWS(this.strActualizarNoti + "/" + this.id, JSON.stringify({leido: 'S'})).subscribe((datosResp3: any) => {
      this.initialize();
    });
  }

  AbrirNotificacion() {
    this.menuEvent.broadcast('ABRIR_NUEVO_TAB', JSON.parse("{ \"SYS02CON\" : \"" + "0" + "\", \"titulo\": \"" + "Notificaciones" + "\", \"Tipo\": \"NOTIFICACION_COMPONENT\",\"PAD18CON\": \"14234\"}"));
    this._removeAllClass('show');
  }

  tieneDeudas(): boolean {
    this.deudas = sessionStorage.getItem('X-AVATAR-TIENE-DEUDA') === 'true';
    return this.deudas;
  }

  AbrirArchivos() {
    if (this.tieneDeudas()) {
      this.mensajeDeudas();
      return;
    }
  
    this.menuEvent.broadcast(
      'ABRIR_NUEVO_TAB',
      JSON.parse("{ \"SYS02CON\" : \"" + "2" +
        "\", \"titulo\": \"" + "Archivos" +
        "\", \"Tipo\": \"ARCHIVOS_COMPONENT\"," +
        "\"PAD18CON\": \"1423456\"}")
    );
  }

  AbrirProfile() {
    this.menuEvent.broadcast('ABRIR_NUEVO_TAB', JSON.parse("{ \"SYS02CON\" : \"" + "3" + "\", \"titulo\": \"" + "Perfil" + "\", \"Tipo\": \"PROFILE_COMPONENT\",\"PAD18CON\": \"1423457\"}"));
  }

  abrirFlexmonster() {
    this.menuEvent.broadcast('ABRIR_NUEVO_TAB', { SYS02CON: 4, titulo: 'Tablas pivote', Tipo: 'FLEXMONSTER_COMPONENT' });
  }

  EventoClickLista(index) {
    this.WsLlaves = index;
    this.id = index;
    this.markUnread();
    this.modalService.open(this.contenido, { size: 'xl' });
  }

  get usuarioSesion(): string { return localStorage.getItem('S00USR') || ''; }
  get iniciales(): string {
    const base = String(this.dataestudiante || this.usuarioSesion || '?').trim();
    const partes = base.split(/\s+/).filter(p => p);
    const ini = partes.length > 1 ? partes[0][0] + partes[1][0] : base.substring(0, 2);
    return ini.toUpperCase();
  }

  abrirCambioContrasena() {
    this.modalService.open(CambiarContrasenaComponent, { centered: true, backdrop: 'static' });
  }

  abrirModal(index) {
    this.dataService.Consultar(this.strMenuCopania).subscribe((datosResp4: any) => {
      this.MenuCopania = datosResp4

      this.dataService.Ejecutar(this.strWsModulo).subscribe((datosResp5: any) => {
        this.MenuModulo = datosResp5;

        let data = {
          LLAVES: [{CNT05COD:this.CNT05COD}]
        };

        this.dataService.Ejecutar(this.strMenuSedesPorCopania, JSON.stringify(data)).subscribe((datosResp6: any) => {

          // almora 2026.05.09 — Carga el combo de Años (CBOPERIODOS) y, si hay M18COD ya elegido,
          // pre-carga los Periodos (cboM20ARC) antes de abrir el modal.
          this.dataService.ConsultarWS(this.strWsCboPeriodos, JSON.stringify({})).subscribe((respAnios: any) => {
            this.anios = (respAnios && respAnios.DATA[0].PERIODOS) ? respAnios.DATA[0].PERIODOS : [];
            const abrirModalConfig = (periodosCargados: any[]) => {
              this.periodos = periodosCargados || [];
		      const modalRef = this.modalService.open(ModalCustomComponent, { size: 'xl' });
		      modalRef.componentInstance.companias = this.MenuCopania[0].COMPANIAS;
		      modalRef.componentInstance.sedes = datosResp6[0].SEDES;
              modalRef.componentInstance.anios = this.anios;
              modalRef.componentInstance.periodos = this.periodos;
		      modalRef.componentInstance.CNT05COD = this.CNT05COD;
		      modalRef.componentInstance.M05COD = this.M05COD;
              modalRef.componentInstance.M18COD = this.M18COD;
              modalRef.componentInstance.M19COD = this.M19COD;
		      modalRef.componentInstance.MostrarFiltroPrincipal = this.MostrarFiltroPrincipal;
		      modalRef.componentInstance.ModuloDefault = this.ModuloDefault;
		      modalRef.componentInstance.MenuModulo = this.MenuModulo;

		      modalRef.componentInstance.origen = 3;
		      modalRef.componentInstance.retornoSeleccionado.subscribe(($e) => {
		          // El modal ya escribio los X-AVATAR-* (incluido M18/M19) y llamo cambiarContextoHeader.
		          // Solo refresco las propiedades locales para que el header refleje los nuevos valores.
		          this.obtener_localstorage();
		        this.guardar();
		      });
              modalRef.componentInstance.cambioPeriodos.subscribe((m18cod: string) => {
                this.cargarPeriodos(m18cod, modalRef);
              });
            }; 

            if (this.M18COD) {
              this.dataService.ConsultarWS(this.strWsCboPeriodoM19, JSON.stringify({ LLAVES: [{ M18COD: this.M18COD }] })).subscribe((respPer: any) => {
                abrirModalConfig((respPer && respPer.DATA[0].PERIODOS) ? respPer.DATA[0].PERIODOS : []);
              }, () => abrirModalConfig([]));
            } else {
              abrirModalConfig([]);
            }
          }, () => {
            // si falla CBOPERIODOS abrir igual sin combos de año/periodo
            this.anios = [];
            const modalRef = this.modalService.open(ModalCustomComponent, { size: 'xl' });
            modalRef.componentInstance.companias = this.MenuCopania[0].COMPANIAS;
            modalRef.componentInstance.sedes = datosResp6[0].SEDES;
            modalRef.componentInstance.CNT05COD = this.CNT05COD;
            modalRef.componentInstance.M05COD = this.M05COD;
            modalRef.componentInstance.MostrarFiltroPrincipal = this.MostrarFiltroPrincipal;
            modalRef.componentInstance.ModuloDefault = this.ModuloDefault;
            modalRef.componentInstance.MenuModulo = this.MenuModulo;
            modalRef.componentInstance.origen = 3;
            modalRef.componentInstance.retornoSeleccionado.subscribe(($e) => {
              this.obtener_localstorage();
              this.guardar();
            });
          });
        });
      });
    });

    if (this.CNT05COD == "" || this.CNT05COD == undefined || this.CNT05COD == null || this.M05COD == "" || this.M05COD == undefined || this.M05COD == null) {
      this.obtener_localstorage();
    }
  }

  // almora 2026.05.09 — Recarga el combo M19COD (cboM20ARC) cuando el usuario cambia M18COD en el modal.
  cargarPeriodos(m18cod: string, modalRef: any) {
    if (!m18cod) {
      this.periodos = [];
      if (modalRef && modalRef.componentInstance) modalRef.componentInstance.periodos = [];
      return;
    }
    const data = { LLAVES: [{ M18COD: m18cod }] };
    this.dataService.ConsultarWS(this.strWsCboPeriodoM19, JSON.stringify(data)).subscribe((respPer: any) => {
      this.periodos = (respPer && respPer.DATA[0].PERIODOS) ? respPer.DATA[0].PERIODOS : [];
      if (modalRef && modalRef.componentInstance) {
        modalRef.componentInstance.periodos = this.periodos;
      }
    });
  }

  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }

  /**
   * Logout the user
   */
  logout() {
    sessionStorage.removeItem('X-AVATAR-TIENE-DEUDA');
    this.authService.logout();

    clearInterval(this.interval);

    this.router.navigate(['/account/login']);
  }

  /**
   * On menu click
   */
  onMenuClick(event) {
    const nextEl = event.target.nextElementSibling;
    if (nextEl) {
      const parentEl = event.target.parentNode;
      if (parentEl) {
        parentEl.classList.remove("show");
      }
      nextEl.classList.toggle("show");
    }
    return false;
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Togglemenu bar
   */
  toggleMenubar() {
    this.ocultarMenu = !this.ocultarMenu;
    /*const element = document.getElementById('topnav-menu-content');
    element.classList.toggle('show');*/
  }

  /**
   * Activates the menu
   */
  private activateMenu() {

    const resetParent = (el: any) => {
      const parent = el.parentElement;
      if (parent) {
        parent.classList.remove('active');
        const parent2 = parent.parentElement;
        this._removeAllClass('mm-active');
        this._removeAllClass('mm-show');
        if (parent2) {
          parent2.classList.remove('active');
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove('active');
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove('active');
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove('active');
                const menuelement = document.getElementById("topnav-menu-content")
                if (menuelement !== null) {
                  if (menuelement.classList.contains('show'))
                    document
                      .getElementById("topnav-menu-content")
                      .classList.remove("show");
                }
              }
            }
          }
        }
      }
    };

    // activate menu item based on location
    const links = document.getElementsByClassName('side-nav-link-ref');
    let matchingMenuItem = null;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // reset menu
      resetParent(links[i]);
    }
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // tslint:disable-next-line: no-string-literal
      if (location.pathname === links[i]['pathname']) {
        matchingMenuItem = links[i];
        break;
      }
    }

    if (matchingMenuItem) {
      const parent = matchingMenuItem.parentElement;
      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add('active');
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.add('active');
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add('active');
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.add('active');
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.add('active');
                const parent6 = parent5.parentElement;
                if (parent6) {
                  parent6.classList.add('active');
                }
              }
            }
          }
        }
      }
    }
  }

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    if (this.tieneDeudas()) {
      this.mensajeDeudas();
      return;
    }
    document.body.classList.toggle('right-bar-enabled');
  }

  /**
   * Fullscreen method
   */
  toggleHorizontalLayout() {
    this.eventService.broadcast('changeLayout', 'vertical');
  }

  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  /**
   * Change the layout onclick
   * @param layout Change the layout
   */
  changeLayout(layout: string) {
    this.eventService.broadcast('changeLayout', layout);
  }


  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.OPCIONES !== undefined ? item.OPCIONES.length > 0 : false;
  }

  // almora 2022.03.05 Abrir Tab desde el Menu Principal
  AbrirMenu(intSYS02CON, descripcion, strSYS02TIP) {
    if (this.tieneDeudas()) {
      this.mensajeDeudas();
      return;
    }
  
    this.menuEvent.broadcast(
      'ABRIR_NUEVO_TAB',
      JSON.parse("{  \"SYS02CON\" : \"" + intSYS02CON +
        "\", \"SYS02TIP\" : \"" + strSYS02TIP +
        "\", \"titulo\"   : \"" + descripcion + "\"}")
    );
  
    this._removeAllClass('show');
  }

  initialize3(): void {
    this.megamenu = [];
    this.cargandoFavoritos = true;
    this.dataService.Consultar(this.strWsURL).subscribe(
      (datosResp: any) => {
        this.array = datosResp;
        var opmegamenu: any = [];
        this.array.sort((a, b) => {
          if (a["SYS02DES"].toLowerCase() > b["SYS02DES"].toLowerCase()) {
            return 1;
          }
          if (a["SYS02DES"].toLowerCase() < b["SYS02DES"].toLowerCase()) {
            return -1;
          }
          return 0;
        })
        var contador = 0;
        for (var i = 0; i < this.array.length; i++) {
          opmegamenu.push(this.array[i]);
          contador++;
          if (contador > 3) {
            this.megamenu.push(opmegamenu);
            opmegamenu = [];
            contador = 0;
          }
        }
        this.megamenu.push(opmegamenu);
        this.favoritos = this.array || [];
        this.cargandoFavoritos = false;
      },
      () => {
        this.favoritos = [];
        this.cargandoFavoritos = false;
      });
  }

  cargarToolbar() {
    this.initialize3();
  }

  get favoritosFiltrados(): any[] {
    const texto = this.normalizarTexto(this.filtroFavoritos);
    if (!texto) {
      return this.favoritos;
    }
    return this.favoritos.filter(f => this.normalizarTexto(f.SYS02DES).includes(texto));
  }

  inicialFavorito(descripcion: any): string {
    const limpio = String(descripcion ?? '').trim();
    return limpio ? limpio.charAt(0).toUpperCase() : '★';
  }

  abrirFavorito(fav: any, drop: NgbDropdown) {
    drop.close();
    this.filtroFavoritos = '';
    this.AbrirMenu(fav.SYS02CON, fav.SYS02DES, fav.SYS02TIP);
  }

  abrirPrimerFavorito(drop: NgbDropdown) {
    const primero = this.favoritosFiltrados[0];
    if (primero) {
      this.abrirFavorito(primero, drop);
    }
  }

  enfocarBuscadorFavoritos(input: HTMLInputElement | undefined) {
    setTimeout(() => input?.focus(), 150);
  }

  private normalizarTexto(valor: any): string {
    return String(valor ?? '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .trim();
  }

  event(event) {
    var position = event.target.parentElement.getBoundingClientRect();
    var menu = event.target.childNodes[1];
    var lista = event.target.parentElement.childNodes;
    var padreclick = event.target.id;
    var hijos = menu.childElementCount;
    if (hijos > 4) {
      if (padreclick >= 6) {
        menu.style.position = "fixed";
        menu.style.setProperty("top", position.top + ((padreclick - 6) * 37) + 'px', "important");
        menu.style.left = (position.width) + 'px';
      } else {
        menu.style.position = "fixed";
        menu.style.top = position.top + 'px';
        menu.style.left = (position.width) + 'px';
      }
    }
  }

  cerrar() {
    this.modalService.dismissAll();
  }

  guardar() {
    this.obtener_localstorage();
    if (this.ModuloDefault != '' || this.ModuloDefault != undefined) {
      let filtro = "";
      let jsonFiltros = JSON.parse("{ \"FILTROS_OPCIONALES\"   : [ { \"S14DES\" : \"" + filtro + "\", \"S02COD\" : \"" + this.ModuloDefault + "\" }]}");
      this.dataService.Ejecutar(this.strWsURLMENU, jsonFiltros).subscribe(
        (datosResp: any) => {
          this.menuItems = datosResp;
          this.ModuloModalDefault = datosResp[0].S02COD;
        });
    }
  }

  grabar_localstorage() {
    // almora 2026.05.09 — Cambio de globales desde el header: limpia particulares y resetea globales.
    // Llamar ANTES de actualizar X-AVATAR-* para que detecte el cambio comparando contra el valor previo.
    this.filtrosPersistencia.cambiarContextoHeader(this.CNT05COD, this.M05COD, this.M18COD, this.M19COD);

    localStorage.setItem("X-AVATAR-CNT05COD", this.CNT05COD);
    localStorage.setItem("X-AVATAR-M05COD", this.M05COD)
    localStorage.setItem("X-AVATAR-CNT05DES", this.CNT05DES);
    localStorage.setItem("X-AVATAR-M05DES", this.M05DES)

    localStorage.setItem("X-AVATAR-MOSTRARFILTRO", this.MostrarFiltroPrincipal)
    localStorage.setItem("X-AVATAR-MODULODEFAULT", this.ModuloDefault)
  }

  obtener_localstorage() {
    this.CNT05COD = localStorage.getItem("X-AVATAR-CNT05COD");
    this.CNT05DES = localStorage.getItem("X-AVATAR-CNT05DES");

    this.M05COD = localStorage.getItem("X-AVATAR-M05COD");
    this.M05DES = localStorage.getItem("X-AVATAR-M05DES");
    this.M18COD = localStorage.getItem("X-AVATAR-M18COD");
    this.M19COD = localStorage.getItem("X-AVATAR-M19COD");
    this.MostrarFiltroPrincipal = localStorage.getItem("X-AVATAR-MOSTRARFILTRO");
    this.ModuloDefault = localStorage.getItem("X-AVATAR-MODULODEFAULT");
  }

  timerAlertas() {
    this.interval = setInterval(() => {

      this.dataService.ConsultarWS(this.strWsnoti, JSON.stringify({ filtro: 'N', resumido: 0, spinner: 0 })).subscribe((datosResp2: any) => {
        this.notificaciones = datosResp2.DATA;
        this.cantidad = this.notificaciones.length;
      });

    },600000);
  }

  getParametrosCliente(){
    return PARAMETROS_CLIENTE;
  }

  mensajeDeudas() {
    Swal.fire({
      title: 'Acceso restringido',
      text: 'Tienes deudas pendientes. Regulariza tu situación para continuar navegando.',
      icon: 'warning',
      confirmButtonText: 'Pagar',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.menuEvent.broadcast('PAGAR_DEUDAS');
      }
    });
  }

  clickAccion(event: Event, accion: any) {
    event.preventDefault();
  
    if (this.tieneDeudas()) {
      this.mensajeDeudas();
      return;
    }
  
    if (accion && accion.PAD34URL) {
      window.open(accion.PAD34URL, '_blank');
    }
  }
}
